// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z224","content":"styles_content__1IPjG","tableWrap":"styles_tableWrap__3XOor"};